module.exports = "textarea{width:100%;height:4em}\n"